import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _SidebarCustomSection;
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { getOwner } from "@ember/owner";
import { service } from "@ember/service";
import { or } from "truth-helpers";
import replaceEmoji from "discourse/helpers/replace-emoji";
import CommonCommunitySection from "discourse/lib/sidebar/common/community-section/section";
import Section from "discourse/lib/sidebar/section";
import AdminCommunitySection from "discourse/lib/sidebar/user/community-section/admin-section";
import MoreSectionLink from "../more-section-link";
import MoreSectionLinks from "../more-section-links";
import SectionComponent from "../section";
import SectionLink from "../section-link";
import SectionLinkButton from "../section-link-button";
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
let SidebarCustomSection = (_class = (_SidebarCustomSection = class SidebarCustomSection extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "currentUser", _descriptor, this);
    _initializerDefineProperty(this, "navigationMenu", _descriptor2, this);
    _initializerDefineProperty(this, "site", _descriptor3, this);
    _initializerDefineProperty(this, "siteSettings", _descriptor4, this);
    _initializerDefineProperty(this, "section", _descriptor5, this);
  }
  willDestroy() {
    super.willDestroy();
    this.section.teardown?.();
  }
  get initialSection() {
    const opts1 = {
      section: this.args.sectionData,
      owner: getOwner(this)
    };
    if (this.args.sectionData.section_type !== "community") {
      return new Section(opts1);
    }
    if (this.currentUser?.admin) {
      return new AdminCommunitySection(opts1);
    } else {
      return new CommonCommunitySection(opts1);
    }
  }
}, setComponentTemplate(createTemplateFactory(
/*
  
    <SectionComponent
      @sectionName={{this.section.slug}}
      @headerLinkText={{this.section.decoratedTitle}}
      @indicatePublic={{this.section.indicatePublic}}
      @collapsable={{@collapsable}}
      @headerActions={{this.section.headerActions}}
      @headerActionsIcon={{this.section.headerActionIcon}}
      @hideSectionHeader={{this.section.hideSectionHeader}}
      class={{this.section.dragCss}}
    >
      {{#each this.section.links as |link|}}
        <SectionLink
          @badgeText={{link.badgeText}}
          @content={{replaceEmoji link.text}}
          @currentWhen={{link.currentWhen}}
          @href={{or link.value link.href}}
          @linkClass={{link.linkDragCss}}
          @linkName={{link.name}}
          @model={{link.model}}
          @models={{link.models}}
          @prefixType="icon"
          @prefixValue={{link.prefixValue}}
          @query={{link.query}}
          @route={{link.route}}
          @shouldDisplay={{link.shouldDisplay}}
          @suffixCSSClass={{link.suffixCSSClass}}
          @suffixType={{link.suffixType}}
          @suffixValue={{link.suffixValue}}
          @title={{link.title}}
        />
      {{/each}}

      {{#if this.section.moreLinks}}
        {{#if this.navigationMenu.isDesktopDropdownMode}}
          {{#each this.section.moreLinks as |sectionLink|}}
            <MoreSectionLink @sectionLink={{sectionLink}} />
          {{/each}}

          {{#if this.section.moreSectionButtonAction}}
            <SectionLinkButton
              @action={{this.section.moreSectionButtonAction}}
              @icon={{this.section.moreSectionButtonIcon}}
              @text={{this.section.moreSectionButtonText}}
            />
          {{/if}}
        {{else if this.section.moreLinks}}
          <MoreSectionLinks
            @sectionLinks={{this.section.moreLinks}}
            @moreButtonAction={{this.section.moreSectionButtonAction}}
            @moreButtonText={{this.section.moreSectionButtonText}}
            @moreButtonIcon={{this.section.moreSectionButtonIcon}}
          />
        {{/if}}
      {{else if this.section.moreSectionButtonAction}}
        <SectionLinkButton
          @action={{this.section.moreSectionButtonAction}}
          @icon={{this.section.moreSectionButtonIcon}}
          @text={{this.section.moreSectionButtonText}}
        />
      {{/if}}
    </SectionComponent>
  
*/
{
  "id": "6ND6u+IK",
  "block": "[[[1,\"\\n    \"],[8,[32,0],[[16,0,[30,0,[\"section\",\"dragCss\"]]]],[[\"@sectionName\",\"@headerLinkText\",\"@indicatePublic\",\"@collapsable\",\"@headerActions\",\"@headerActionsIcon\",\"@hideSectionHeader\"],[[30,0,[\"section\",\"slug\"]],[30,0,[\"section\",\"decoratedTitle\"]],[30,0,[\"section\",\"indicatePublic\"]],[30,1],[30,0,[\"section\",\"headerActions\"]],[30,0,[\"section\",\"headerActionIcon\"]],[30,0,[\"section\",\"hideSectionHeader\"]]]],[[\"default\"],[[[[1,\"\\n\"],[42,[28,[31,1],[[28,[31,1],[[30,0,[\"section\",\"links\"]]],null]],null],null,[[[1,\"        \"],[8,[32,1],null,[[\"@badgeText\",\"@content\",\"@currentWhen\",\"@href\",\"@linkClass\",\"@linkName\",\"@model\",\"@models\",\"@prefixType\",\"@prefixValue\",\"@query\",\"@route\",\"@shouldDisplay\",\"@suffixCSSClass\",\"@suffixType\",\"@suffixValue\",\"@title\"],[[30,2,[\"badgeText\"]],[28,[32,2],[[30,2,[\"text\"]]],null],[30,2,[\"currentWhen\"]],[28,[32,3],[[30,2,[\"value\"]],[30,2,[\"href\"]]],null],[30,2,[\"linkDragCss\"]],[30,2,[\"name\"]],[30,2,[\"model\"]],[30,2,[\"models\"]],\"icon\",[30,2,[\"prefixValue\"]],[30,2,[\"query\"]],[30,2,[\"route\"]],[30,2,[\"shouldDisplay\"]],[30,2,[\"suffixCSSClass\"]],[30,2,[\"suffixType\"]],[30,2,[\"suffixValue\"]],[30,2,[\"title\"]]]],null],[1,\"\\n\"]],[2]],null],[1,\"\\n\"],[41,[30,0,[\"section\",\"moreLinks\"]],[[[41,[30,0,[\"navigationMenu\",\"isDesktopDropdownMode\"]],[[[42,[28,[31,1],[[28,[31,1],[[30,0,[\"section\",\"moreLinks\"]]],null]],null],null,[[[1,\"            \"],[8,[32,4],null,[[\"@sectionLink\"],[[30,3]]],null],[1,\"\\n\"]],[3]],null],[1,\"\\n\"],[41,[30,0,[\"section\",\"moreSectionButtonAction\"]],[[[1,\"            \"],[8,[32,5],null,[[\"@action\",\"@icon\",\"@text\"],[[30,0,[\"section\",\"moreSectionButtonAction\"]],[30,0,[\"section\",\"moreSectionButtonIcon\"]],[30,0,[\"section\",\"moreSectionButtonText\"]]]],null],[1,\"\\n\"]],[]],null]],[]],[[[41,[30,0,[\"section\",\"moreLinks\"]],[[[1,\"          \"],[8,[32,6],null,[[\"@sectionLinks\",\"@moreButtonAction\",\"@moreButtonText\",\"@moreButtonIcon\"],[[30,0,[\"section\",\"moreLinks\"]],[30,0,[\"section\",\"moreSectionButtonAction\"]],[30,0,[\"section\",\"moreSectionButtonText\"]],[30,0,[\"section\",\"moreSectionButtonIcon\"]]]],null],[1,\"\\n        \"]],[]],null]],[]]]],[]],[[[41,[30,0,[\"section\",\"moreSectionButtonAction\"]],[[[1,\"        \"],[8,[32,5],null,[[\"@action\",\"@icon\",\"@text\"],[[30,0,[\"section\",\"moreSectionButtonAction\"]],[30,0,[\"section\",\"moreSectionButtonIcon\"]],[30,0,[\"section\",\"moreSectionButtonText\"]]]],null],[1,\"\\n      \"]],[]],null]],[]]],[1,\"    \"]],[]]]]],[1,\"\\n  \"]],[\"@collapsable\",\"link\",\"sectionLink\"],false,[\"each\",\"-track-array\",\"if\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-app/components/sidebar/common/custom-section.js",
  "scope": () => [SectionComponent, SectionLink, replaceEmoji, or, MoreSectionLink, SectionLinkButton, MoreSectionLinks],
  "isStrictMode": true
}), _SidebarCustomSection), _SidebarCustomSection), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "currentUser", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "navigationMenu", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "site", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "siteSettings", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "section", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.initialSection;
  }
})), _class);
export { SidebarCustomSection as default };